import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=a50ad280&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=a50ad280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ad280",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a50ad280')) {
      api.createRecord('a50ad280', component.options)
    } else {
      api.reload('a50ad280', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=a50ad280&scoped=true&", function () {
      api.rerender('a50ad280', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bW5QCUA7qngW/JS/comp/GuestBox.vue"
export default component.exports